import React from 'react';

import { Badge } from '@mantine/core';
import { IconChevronRight, IconPlus } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ROUTE_LINKS } from 'shared/constants/route-links';
import { SmartAssistant, SmartAssistantType } from 'shared/interfaces/SmartAssistant';

interface SmartAssistantConnectedBadgeProps {
  smartAssistant?: SmartAssistant;
  type: SmartAssistantType;
}

export function SmartAssistantConnectedBadge({ smartAssistant, type }: SmartAssistantConnectedBadgeProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return smartAssistant ? (
    <Badge
      color="green"
      rightSection={<IconChevronRight style={{ width: 16, height: 16, marginTop: 4 }} />}
      style={{ cursor: 'pointer' }}
      tt="capitalize"
      onClick={() => navigate(`${ROUTE_LINKS.manageSmartAssistant}/${smartAssistant._id}`)}>
      {t('SMART_ASSISTANT.CONNECTED')}
    </Badge>
  ) : (
    <Badge
      color="dark.4"
      variant="outline"
      tt="capitalize"
      rightSection={<IconPlus style={{ width: 15, height: 15, marginTop: 4 }} />}
      style={{ cursor: 'pointer' }}
      onClick={() => navigate(`${ROUTE_LINKS.createSmartAssistant}?type=${type}`)}>
      {t('SMART_ASSISTANT.CONNECT')}
    </Badge>
  );
}
